import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import {
  activeTabStyle,
  containerStyle,
  inactiveTabStyle,
  innerContainerStyle,
  tabStyle
} from './styles';

import { useSummariesStore } from '@/store/useSummariesStore.ts';
import { getPlural } from '@/utils/getPlural.ts';

interface TabBarProps {
  activeTabIndex: number;
  handleTabChange: (index: number) => void;
}

const TabBar: FC<TabBarProps> = ({ activeTabIndex, handleTabChange }) => {
  const { t } = useTranslation();

  const { likesCount } = useSummariesStore();

  const likesTitle = useMemo(
    () =>
      getPlural(
        likesCount,
        t,
        {
          zero: 'likes.no_likes',
          one: 'likes.one_like',
          singular: 'likes.x_like',
          few: 'likes.up_to_five_likes',
          many: 'likes.x_likes'
        },
        'likesCount'
      ),
    [likesCount]
  );

  return (
    <div style={containerStyle}>
      <div style={innerContainerStyle}>
        <div
          style={{
            ...tabStyle,
            ...(activeTabIndex === 0 ? activeTabStyle : inactiveTabStyle)
          }}
          onClick={() => handleTabChange(0)}
        >
          {likesTitle}
        </div>
        <div
          style={{
            ...tabStyle,
            ...(activeTabIndex === 1 ? activeTabStyle : inactiveTabStyle)
          }}
          onClick={() => handleTabChange(1)}
        >
          {t('your_likes')}
        </div>
      </div>
    </div>
  );
};

export default TabBar;